import { render, staticRenderFns } from "./icon-brain.vue?vue&type=template&id=12b09d86&scoped=true&"
import script from "./icon-brain.vue?vue&type=script&lang=js&"
export * from "./icon-brain.vue?vue&type=script&lang=js&"
import style0 from "./icon-brain.vue?vue&type=style&index=0&id=12b09d86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b09d86",
  null
  
)

export default component.exports